.subHeaderWrapper {
  background-color: var(--color-easil-black);
  color: white;
  display: flex;
  flex-direction: column;
}

.subHeaderTitle {
  font-family: Roboto;
  font-size: 32px;
  font-weight: 300;
  line-height: 1.19;
  color: #ffffff;
  display: flex;
  flex-direction: row;
}

.subHeaderTitlePrefix {
  margin-right: 10px;
  max-width: 863px;
  max-height: 38px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .subHeaderTitle {
    font-size: 24px;
  }
}
